export default function (axiosInstance, mockdb, mockdbchart, generatedObj) {
  const development = false //import.meta.env.VITE_VUE_APP_BASE_URL === 'http://localhost:8082' || import.meta.env.STORYBOOK === 'true'
  let mock
  const defaultResponseCode = 200
  const buildVersion = '1.0.0.0'

  // if (development) {
  //   MockAdapter = require('axios-mock-adapter')
  //   mock = new MockAdapter(axiosInstance)
  // }

  function getUrlVars(u) {
    let vars = [],
      hash
    let hashes = u.slice(u.indexOf('?') + 1).split('&')
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=')
      vars.push(hash[0])
      vars[hash[0]] = hash[1]
    }
    return vars
  }

  return {
    mockData(url, delay, endpoint, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          console.log(`Response for ${url} [GET] ${statusCode}:`, endpoint, statusCode === 204 ? null : mockdb[endpoint])
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve([statusCode, statusCode === 204 ? null : mockdb[endpoint]])
            }, delay)
          })
        })
      }
    },
    mockPost(url, payload, delay, endpoint, statusCode = defaultResponseCode) {
      if (development) {
        mock.onPost(url).reply(function () {
          console.log(`Response for ${url} [PAYLOAD]:`, payload)
          console.log(`Response for ${url} [POST]:`, mockdb[endpoint])
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve([statusCode, mockdb[endpoint]])
            }, delay)
          })
        })
      }
    },
    mockPut(url, payload, delay, endpoint, statusCode = defaultResponseCode) {
      if (development) {
        mock.onPut(url).reply(function () {
          console.log(`Response for ${url} [PAYLOAD]:`, payload)
          console.log(`Response for ${url} [PUT]:`, mockdb[endpoint])
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve([statusCode, mockdb[endpoint]])
            }, delay)
          })
        })
      }
    },
    mockDelete(url, payload, delay, endpoint, statusCode = defaultResponseCode) {
      if (development) {
        mock.onDelete(url).reply(function () {
          console.log(`Response for ${url} [PAYLOAD]:`, payload)
          console.log(`Response for ${url} [DELETE]:`, mockdb[endpoint])
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve([statusCode, mockdb[endpoint]])
            }, delay)
          })
        })
      }
    },
    mockDeliverySites(url, delay, endpoint1, endpoint2, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            let idFromUrl = ''
            if (url.indexOf('customerId') !== -1) {
              idFromUrl = url.split('/').reverse()[0].split('=')[1]
            } else {
              idFromUrl = url.split('/').reverse()[0]
            }
            setTimeout(function () {
              if (idFromUrl === '234234') {
                console.log(`Response for ${url} [GET]:`, mockdb[endpoint2])
                resolve([statusCode, mockdb[endpoint2]])
              } else {
                console.log(`Response for ${url} [GET]:`, mockdb[endpoint1])
                resolve([statusCode, mockdb[endpoint1]])
              }
            }, delay)
          })
        })
      }
    },
    mockConsumptionData(url, delay, getConsumptionData, getProductionData, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            setTimeout(function () {
              if (url.split('/').reverse()[0] === '735999000000000002' || url.split('/').reverse()[0] === '735999000000000004' || url.split('/').reverse()[0] === '735999000000000008' || url.split('/').reverse()[0] === '735999000000000010') {
                console.log(`Response for ${url} [GET]:`, mockdb[getProductionData])
                resolve([statusCode, mockdb[getProductionData]])
              } else if (url.split('/').reverse()[0] === '735999000000000009') {
                console.log(`Response for ${url} [GET]:`, mockdb[getConsumptionData])
                resolve([statusCode, mockdb[`${getConsumptionData}NoPowerTariff`]])
              } else {
                console.log(`Response for ${url} [GET]:`, mockdb[getConsumptionData])
                resolve([statusCode, mockdb[getConsumptionData]])
              }

              // else if (url.split('/').reverse()[0] === '?customerId=123456') {
              //   console.log('HELLO')
              //   console.log(`Response for ${url} [GET]:`, mockdb.getConsumptionDataMock())
              //   resolve([200, mockdb.getConsumptionDataMock()])
              // } else {
              //   console.log('NO RESPONSE')
              //   console.log(`Response for ${url} [GET]:`, 'NO RESPONSE')
              //   resolve([200, mockdb.getConsumptionDataMock()])
              // }
            }, delay)
          })
        })
      }
    },
    mockConsumptionChartDataDefault(url, delay, resolutionMonth, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            setTimeout(function () {
              const isTariff = url.includes('isPowerTariff=true')
              console.log(`Response for ${url} [GET]:`, mockdbchart[isTariff ? `${resolutionMonth}Tariff` : resolutionMonth])
              resolve([statusCode, mockdbchart[isTariff ? `${resolutionMonth}Tariff` : resolutionMonth]])
            }, delay)
          })
        })
      }
    },
    mockConsumptionChartData(url, delay, resolutionMonth, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            setTimeout(function () {
              console.log(`Response for ${url} [GET]:`, mockdbchart[resolutionMonth])
              resolve([statusCode, mockdbchart[resolutionMonth]])
            }, delay)
          })
        })
      }
    },
    mockConsumptionChartDataGenerated(url, delay, statusCode = defaultResponseCode) {
      if (development) {
        const getClosestPeriod = function (intervalInMillisek) {
          const okDiffDay = 1000 * 60 * 60 * 3 //three hours
          const okDiff = 1000 * 60 * 60 * 24 * 3 //three days
          const day = 1000 * 60 * 60 * 24
          const week = 1000 * 60 * 60 * 24 * 7
          const month = 1000 * 60 * 60 * 24 * 30
          const year = 1000 * 60 * 60 * 24 * 365

          if ((intervalInMillisek - okDiffDay < day && day < intervalInMillisek + okDiffDay) || intervalInMillisek === 0) return 'day'
          else if (intervalInMillisek - okDiff < week && week < intervalInMillisek + okDiff) return 'week'
          else if (intervalInMillisek - okDiff < month && month < intervalInMillisek + okDiff) return 'month'
          else if (year < intervalInMillisek + okDiff || (intervalInMillisek - okDiff < year && year < intervalInMillisek + okDiff)) return 'year'
          else return ''
        }

        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            setTimeout(function () {
              const res = getUrlVars(url)['resolution']
              const interval = getUrlVars(url)['interval']
              let from = decodeURIComponent(getUrlVars(url)['from'])
              let to = decodeURIComponent(getUrlVars(url)['to'])

              const previous = decodeURIComponent(getUrlVars(url)['previous']) === 'true'
              const next = decodeURIComponent(getUrlVars(url)['next']) === 'true'
              const step = getClosestPeriod(new Date(to).getTime() - new Date(from).getTime())

              if (previous && step !== '') {
                if (step === 'year') {
                  from = new Date(new Date(from).setFullYear(new Date(from).getFullYear() - 1)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setFullYear(new Date(to).getFullYear() - 1)).toISOString().substring(0, 10)
                } else if (step === 'month') {
                  from = new Date(new Date(from).setMonth(new Date(from).getMonth() - 1)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setMonth(new Date(to).getMonth() - 1)).toISOString().substring(0, 10)
                } else if (step === 'week') {
                  from = new Date(new Date(from).setDate(new Date(from).getDate() - 7)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setDate(new Date(to).getDate() - 7)).toISOString().substring(0, 10)
                } else if (step === 'day') {
                  from = new Date(new Date(from).setDate(new Date(from).getDate() - 1)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setDate(new Date(to).getDate() - 1)).toISOString().substring(0, 10)
                }
              }
              if (next && step !== '') {
                if (step === 'year') {
                  from = new Date(new Date(from).setFullYear(new Date(from).getFullYear() + 1)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setFullYear(new Date(to).getFullYear() + 1)).toISOString().substring(0, 10)
                } else if (step === 'month') {
                  from = new Date(new Date(from).setMonth(new Date(from).getMonth() + 1)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setMonth(new Date(to).getMonth() + 1)).toISOString().substring(0, 10)
                } else if (step === 'week') {
                  from = new Date(new Date(from).setDate(new Date(from).getDate() + 7)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setDate(new Date(to).getDate() + 7)).toISOString().substring(0, 10)
                } else if (step === 'day') {
                  from = new Date(new Date(from).setDate(new Date(from).getDate() + 1)).toISOString().substring(0, 10)
                  to = new Date(new Date(to).setDate(new Date(to).getDate() + 1)).toISOString().substring(0, 10)
                }
              }

              const comparePrevious = getUrlVars(url)['comparePrevious']
              const comparePreviousYear = getUrlVars(url)['comparePreviousYear']

              console.log(`%c Mock Data Generated - from: ${from}, to: ${to} `, 'background: #ebebff; color: #3a3a72')
              console.log(`%c Mock Data Generated - interval: ${interval}, resolution: ${res} `, 'background: #ebebff; color: #3a3a72')

              const responseObject = generatedObj.interval(from, to, res, interval)

              if (interval === 'All') {
                responseObject.data.comparePrevious = false
                responseObject.data.comparePreviousYear = false
              }

              if (comparePrevious || comparePreviousYear) {
                let parsedTo = new Date(to)
                let parsedFrom = new Date(from)

                if (comparePrevious) {
                  parsedTo = new Date(new Date(to).setMonth(parsedTo.getMonth() - 1))
                  parsedFrom = new Date(new Date(from).setMonth(parsedFrom.getMonth() - 1))
                } else if (comparePreviousYear) {
                  parsedTo = new Date(new Date(to).setFullYear(parsedTo.getFullYear() - 1))
                  parsedFrom = new Date(new Date(from).setFullYear(parsedFrom.getFullYear() - 1))
                }

                const responseCompareObject = generatedObj.interval(parsedFrom, parsedTo, res, interval)
                responseObject.data.compareData = responseCompareObject.data
                responseObject.data.compareData.energyForPeriod = (Math.random() * 100000).toFixed(1)
              }

              const returnObject = {
                ...responseObject,
                meta: {
                  version: buildVersion
                },
                messages: ['Något gick fel när ny data skulle hämtas.'],
                errors: []
              }

              console.log(`Response for ${url}:`, returnObject)
              //console.log(`%c Response for:${'\n'}/api/${url.split('/api/')[1]}${'\n'} @ ${url.split('/api/')[0].split('://')[1]} `, 'font-size: 14px; background: #ebebff; color: #3a3a72; padding: 12px 8px; border-radius:5px', responseObject)

              resolve([statusCode, returnObject])
            }, delay)
          })
        })
      }
    },
    mockEffectChartDataGenerated(url, delay, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            setTimeout(function () {
              const res = getUrlVars(url)['resolution']
              const interval = getUrlVars(url)['interval']
              const from = decodeURIComponent(getUrlVars(url)['from'])
              const to = decodeURIComponent(getUrlVars(url)['to'])

              const responseObject = generatedObj.effect(from, to, res, interval)
              console.log(`Response for ${url}:`, responseObject)

              resolve([statusCode, responseObject])
            }, delay)
          })
        })
      }
    },
    mockTemperatureChartDataGenerated(url, delay, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            setTimeout(function () {
              const res = getUrlVars(url)['resolution']
              const interval = getUrlVars(url)['interval']
              const from = decodeURIComponent(getUrlVars(url)['from'])
              const to = decodeURIComponent(getUrlVars(url)['to'])

              const responseObject = generatedObj.temperature(from, to, res, interval)
              console.log(`Response for ${url}:`, responseObject)

              resolve([statusCode, responseObject])
            }, delay)
          })
        })
      }
    },
    mockPowerOutageNotificationTableData(url, delay, payload, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          return new Promise(function (resolve) {
            const newData = {
              data: {
                items: []
              },
              meta: {
                totalItemsCount: 122
              },
              messages: ['Här var det tomt', 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In venenatis varius ante, nec lobortis mauris vehicula id. Pellentesque ut arcu sceler.'],
              errors: []
            }

            const payloadParsed = new URLSearchParams(payload.params)
            const currentCount = payloadParsed.get('currentCount')
            const additionalItemsCount = payloadParsed.get('additionalItemsCount')

            for (let i = 0; i < additionalItemsCount; i++) {
              const newIndex = +currentCount + i + 1
              newData.data.items.push([
                {
                  type: 'id',
                  value: 'radens-id-' + newIndex
                },
                {
                  type: 'selectable',
                  value: false
                },
                {
                  type: 'boolean',
                  value: newIndex % 2 === 0,
                  text: newIndex % 2 === 0 ? 'Aktiv' : 'Inaktiv',
                  noIcon: true
                },
                `Demogatan ${newIndex} (735999) 000 000 000 00${newIndex}`,
                {
                  type: 'array',
                  content: 'phoneList',
                  valueFormatted: newIndex % 2 === 0 ? ['+46 70 123 45 60', '+46 70 123 45 61', '+46 70 123 45 62'] : ['+46 70 123 45 62'],
                  value: newIndex % 2 === 0 ? ['+46701234560', '+46701234561', '+46701234562'] : ['+46701234562']
                },
                {
                  type: 'array',
                  content: 'emailList',
                  value: newIndex % 2 === 0 ? ['demo@demosson.se', 'test@testsson.com'] : []
                }
              ])
            }

            console.log(`Response for ${url} [GET]:`, newData)

            setTimeout(function () {
              resolve([statusCode, newData])
            }, delay)
          })
        })
      }
    },
    mockDeliverySiteTableData(url, delay, endpoint, payload, statusCode = defaultResponseCode) {
      if (development) {
        mock.onGet(url).reply(function () {
          let mockedEndPoint = 'getDeliverySitesData'
          if (payload.groupsActive) mockedEndPoint = 'getDeliverySitesDataGroups'
          else if (payload.groupId) mockedEndPoint = 'getGroupData'

          const responseData = mockdb[mockedEndPoint]

          if (endpoint !== 'getCurrentSession') console.log(`Response for ${url} [GET] ${statusCode}:`, mockedEndPoint, statusCode === 204 ? null : responseData)
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve([statusCode, statusCode === 204 ? null : responseData])
            }, delay)
          })
        })
      }
    }
  }
}
